module.exports = __webpack_public_path__ + "static/media/1_r_bust_89.38_50.19.78f8dcfa.png";